module.exports = __webpack_public_path__ + "static/media/LK_Billing.3ea3cecd.svg";